"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateIn = void 0;
class GenerateIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return GenerateIn.attributeTypeMap;
    }
}
exports.GenerateIn = GenerateIn;
GenerateIn.discriminator = undefined;
GenerateIn.attributeTypeMap = [
    {
        "name": "prompt",
        "baseName": "prompt",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=GenerateIn.js.map